module.exports = "/assets/images/dislike_b2fc49.svg";